import { cn } from "../../lib/cn.js";

interface Props {
  label: string;
  value: string;
  /** A secondary line under the value. Optional; omitted rather than empty. */
  note?: string | undefined;
  tone?: "normal" | "accent";
}

/**
 * One figure with its name.
 *
 * The label is a real `<dt>` inside the caller's `<dl>` in the places that
 * have several of these, and a plain heading where there is one -- so this
 * takes the words and leaves the list semantics to the caller rather than
 * inventing a `<div role="term">`.
 */
export function Stat({ label, value, note, tone = "normal" }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm text-ink-muted">{label}</span>
      <span
        className={cn(
          "tabular text-2xl font-semibold tracking-tight sm:text-3xl",
          tone === "accent" ? "text-accent-ink" : "text-ink",
        )}
      >
        {value}
      </span>
      {note !== undefined && <span className="text-xs text-ink-muted">{note}</span>}
    </div>
  );
}
